// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const SearchHistoryService = {
    RegisterQuery(fn, req) {
        return fn(`/search/history/v1/query:register`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    RegisterClick(fn, req) {
        return fn(`/search/history/v1/click:register`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
